import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
    Box,
    Card,
    DataLegend,
    InternalGrid,
    Text,
    SkeletonItem,
} from '@paygreen/paygreen-ui';
import { IsMobile } from '../../../utils/tools';
import IconByName from '../../../utils/IconByName';
import { generateCO2DataOrigins } from './co2OriginsTools';

export const GreyFilter = styled.div`
    .grey-filter {
        & * {
            filter: ${(props) =>
                props.isActive ? 'grayscale(1)' : 'grayscale(0)'};
        }
    }
`;

const DashboardCardOrigins = ({ t, reportsData, isLoading }) => {
    const dataCO2Origins = generateCO2DataOrigins(reportsData, t);

    return (
        <InternalGrid
            displayType="grid"
            gridGap="md"
            justifyItems="stretch"
            gridTemplateColumns={IsMobile() ? '1fr' : '1fr 1fr 1fr'}
        >
            {dataCO2Origins.map((card, index) => (
                <SkeletonItem
                    key={index}
                    skeletonItemType="text"
                    blockWidth="md"
                    colorWab="grey10"
                    radiusSize="sm"
                    isLoading={isLoading}
                >
                    <Card
                        key={index}
                        colorWab="white20"
                        shadowSize="none"
                        blockWidth="md"
                        radiusSize="sm"
                    >
                        <GreyFilter isActive={!card.value}>
                            <Box
                                marginTop="md"
                                marginBottom="md"
                                className="grey-filter"
                            >
                                <InternalGrid
                                    displayType="grid"
                                    gridTemplateColumns="1fr"
                                    alignItems="center"
                                    childrenMarginLateral="sm"
                                    childrenMarginTop="xs"
                                    childrenMarginBottom="xs"
                                >
                                    <Text
                                        colorWab="grey50"
                                        textSize="xs"
                                        align="center"
                                        hasUppercase={true}
                                    >
                                        {card.type}
                                    </Text>

                                    <InternalGrid
                                        displayType="grid"
                                        gridGap="md"
                                        gridTemplateColumns="auto auto"
                                        alignItems="center"
                                    >
                                        <IconByName
                                            name={card.icon}
                                            iconSize="md"
                                            colorPallet="status"
                                        />
                                        <DataLegend
                                            textSize="sm"
                                            value={card.value || 0}
                                            unit="%"
                                            colorPallet="status"
                                        />
                                    </InternalGrid>
                                </InternalGrid>
                            </Box>
                        </GreyFilter>
                    </Card>
                </SkeletonItem>
            ))}
        </InternalGrid>
    );
};

DashboardCardOrigins.propTypes = {
    reportsData: PropTypes.object,
    isLoading: PropTypes.bool,
};

DashboardCardOrigins.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(DashboardCardOrigins);
